<div #sidebarContentWrapper (scroll)="onScroll($event)" [class.scrolled]="setOpacity" class="sidebar-content-wrapper {{ mode }}" [ngClass]="{
    collpased: mode == 'push' && collapsed,
    expand: mode == 'push' && !collapsed
  }" [attr.data-transaction-name]="'sidebar-content'">  <ng-content></ng-content>
</div>
